<template>
  <div class="policies">
    <h2 class="policies__title" v-if="title">{{ title }}</h2>

    <div
      class="policies__check"
      v-if="data.Type === 2 || data.Type === 3"
    >
      <label
        v-for="(check, idx) in data.Checkboxes"
        :key="idx"
      >
        <Checkbox v-model="check.Value" :binary="true"/>
        {{ check.ClaimName }}
      </label>
    </div>

    <table
      class="policies__table"
      v-if="data.Type === 1 || data.Type === 3"
    >
      <thead>
        <tr>
          <th>Полномочия</th>
          <th
            v-for="(column, idx) in data.Columns"
            :key="idx"
          >
            {{ column.Title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, idx) in data.Rows"
          :key="idx"
        >
          <th>{{ row.Name }}</th>
          <td
            v-for="(cell, idx) in row.Values"
            :key="idx"
          >
            <Checkbox v-model="cell.Value" :binary="true" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Checkbox from 'primevue/checkbox'

export default {
  name: 'RolesEditorProjectsPolicies',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    }
  },
  components: {
    Checkbox
  }
}
</script>

<style lang="scss" scoped>
.policies {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0;
  overflow-x: auto;

  &__title {
    padding: 3px 12px;
    width: 100%;
    margin-bottom: 20px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 110% */
    letter-spacing: -0.4px;
    text-align: left;
    color: #000000;
    background-color: #E6E6E6;
  }

  &__table {
    // width: 100%;
    // overflow: auto;
    border: 1px solid #E6E6E6;
    border-collapse: collapse;

    td {
      border: 1px solid #E6E6E6;
    }

    th {
      // width: 140px;
      padding: 10px 10px;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      text-align: center;
      vertical-align: top;
      border: 1px solid #E6E6E6;

      &:nth-child(1) {
        width: 30%;
        padding: 10px 10px;
        text-align: start;
      }
    }

    thead {
      background-color: #E6E6E6;
      color: #787878;
    }
  }

  &__check {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
}
</style>
